"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INBOUND_ACTIONS = exports.REGION_TYPE = exports.FAQ_TYPES = exports.MENU_ITEM_STYLING = exports.MENU_ITEM_STYLING_BUTTON = exports.MENU_ITEM_STYLING_LINK = exports.MENU_ITEM_TYPE = exports.DEFAULT_MENU_ITEM = exports.DEFAULT_MENU_TYPES = exports.MENU_ELEMENT_TYPE = exports.MENU_ELEMENT_TYPES = exports.MENU_ITEM_TYPES = exports.CURRENCY_TYPE = exports.CURRENCY = exports.LANGUAGE_TYPE = exports.EVENT_TYPE = exports.TICKET_ATTENDEE_TYPE = exports.TICKET_VISIBILITY = exports.BOOLEAN_TYPE = void 0;
exports.BOOLEAN_TYPE = [0, 1];
exports.TICKET_VISIBILITY = ["public", "private", "event"];
exports.TICKET_ATTENDEE_TYPE = ["sp", "de", "ex"];
exports.EVENT_TYPE = ["hybrid", "virtual", "onsite"];
exports.LANGUAGE_TYPE = ["de", "en"];
exports.CURRENCY = {
    EUR: "EUR",
    USD: "USD",
};
exports.CURRENCY_TYPE = [exports.CURRENCY.EUR, exports.CURRENCY.USD];
// Update MENU_ITEM_TYPES to include MAILING
exports.MENU_ITEM_TYPES = {
    INTERNAL: "internal",
    EXTERNAL: "external",
    MAILING: "mailto",
    DOWNLOAD: "download",
    APPLY_AS_SPEAKER: "apply-as-speaker",
    BECOME_PARTNER: "become-partner",
};
// Add MENU_ELEMENT_TYPES (new constant)
exports.MENU_ELEMENT_TYPES = {
    ITEM: "item",
    BUTTON: "button",
};
exports.MENU_ELEMENT_TYPE = ["item", "button"];
// Keep existing DEFAULT_MENU_TYPES as is
exports.DEFAULT_MENU_TYPES = {
    HOME: "home",
    AGENDA: "agenda",
    SPEAKER: "speaker",
    PARTNER: "partner",
    WHO_WHY: "who-&-why",
    EVENT_INFO: "event-info",
    CONTENT_HUB: "content-hub",
};
exports.DEFAULT_MENU_ITEM = [
    "home",
    "agenda",
    "speaker",
    "partner",
    "who-&-why",
    "event-info",
    "content-hub",
];
// Update MENU_ITEM_TYPE to include "mailto"
exports.MENU_ITEM_TYPE = [
    "home",
    "agenda",
    "speaker",
    "partner",
    "who-&-why",
    "event-info",
    "content-hub",
    "internal",
    "external",
    "mailto",
];
// Define constants for styling: 0 for link, 1 for button
exports.MENU_ITEM_STYLING_LINK = 0;
exports.MENU_ITEM_STYLING_BUTTON = 1;
// Add MENU_ITEM_STYLING object for backwards compatibility
exports.MENU_ITEM_STYLING = {
    LINK: exports.MENU_ITEM_STYLING_LINK,
    BUTTON: exports.MENU_ITEM_STYLING_BUTTON,
};
exports.FAQ_TYPES = {
    DEFAULT_IMAGE_RIGHT: "default-image-right",
    DEFAULT_IMAGE_LEFT: "default-image-left",
    EXTENDED_IMAGES_RIGHT: "extended-images-right",
    EXTENDED_IMAGES_LEFT: "extended-images-left",
    VENUE_LOCATION: "venue-location",
    HOTEL_RESERVATION: "hotel-reservation",
    PRE_EVENT_SESSION: "pre-event-session",
    NETWORKING_DINNER: "networking-dinner",
    MODERATOR_GUIDE: "moderator-guide",
    MATCHMAKING: "matchmaking",
    PLAIN: "plain",
    CONTACT: "contact",
};
exports.REGION_TYPE = ["asia", "europe", "usa"];
exports.INBOUND_ACTIONS = {
    DOWNLOAD_ATTENDEE_LIST: "download_attendee_list",
    DOWNLOAD_WHITE_PAPER: "download_whitepaper",
    DOWNLOAD_MEDIA_PACKAGE: "download_mediapackage",
    DOWNLOAD_AGENDA: "download_agenda",
    WEBAPP_PARTNER: "webapp_partner",
    WEBAPP_SPEAKER: "webapp_speaker",
    WEBAPP_FREE_TICKET_ONSITE: "webapp_freeticket_onsite",
    VIDEO_CONTENT: "video_content",
    TRIAL_ACCOUNT: "trial_account",
    NEWSLETTER: "newsletter",
    INQUIRY: "inquiry",
    CONTACT_FORM: "contact_form",
    SURVEY_MONKEY: "survey_monkey",
    PODCAST_CONTENT: "podcast_content",
    PAGE_VIEW: "page_view",
    DOWNLOAD_BP_PACKAGES: "download_bp_packages",
};
